import { useTranslation } from "react-i18next";
// import { DiagnosisPrivateDataTypePerformanceEnum } from "shared/enums/DiagnosisPrivateDataTypePerformance";

interface ComparisonExplainProps {
  performance?: string;
  development?: string;
  evolutionProcess: string;
  evolutionCost: string;
  criteriaRelevance: string;
  failSensation: string;
  successSensation: string;
  whatToDo: string;
  performanceStatus: number;
  criteriaRelevanceStatus: number;
}

const enumToi18N = [
  "low",
  "average",
  "high",
  "initial",
  "intermediary",
  "advanced",
  "none",
];
const ComparisonExplain: React.FC<ComparisonExplainProps> = (props) => {
  const {
    // performance,
    // development,
    // evolutionProcess,
    // evolutionCost,
    criteriaRelevance,
    failSensation,
    successSensation,
    whatToDo,
    // performanceStatus,
    criteriaRelevanceStatus,
  } = props;
  const { t } = useTranslation("radar");
  return (
    <div className="comparison-explain">
      {/* {performance && (
        <div>
          <p>
            <b>
              {t("pages.CareerDiagnose.comparisonPerformance")}
              {` `}
            </b>
            {performanceStatus < DiagnosisPrivateDataTypePerformanceEnum.None
              ? t(`pages.CareerDiagnose.${enumToi18N[performanceStatus]}`, {
                  context: "female",
                })
              : performance}
          </p>
        </div>
      )}
      {development && (
        <div>
          <p>
            <b>
              {t("pages.CareerDiagnose.comparisonDevelopment")}
              {` `}
            </b>
            {performanceStatus < DiagnosisPrivateDataTypePerformanceEnum.None
              ? t(`pages.CareerDiagnose.${enumToi18N[performanceStatus]}`)
              : development}
          </p>
        </div>
      )}
      <div>
        <p>
          <b>{t("pages.CareerDiagnose.comparisonExplain")}</b> {` `}
          {evolutionProcess}
        </p>
      </div> 
      <div>
        <p>
          <b>{t("pages.CareerDiagnose.comparisonEvolutionCost")}</b> {` `}
          {evolutionCost}
        </p>
      </div> */}
      <div>
        <p>
          <b>{t("pages.CareerDiagnose.comparisonCriteriaRelevance")}</b> {` `}
          {criteriaRelevanceStatus
            ? t(`pages.CareerDiagnose.${enumToi18N[criteriaRelevanceStatus]}`, {
                context: "male",
              })
            : criteriaRelevance}
        </p>
      </div>
      <div>
        <p>
          <b>{t("pages.CareerDiagnose.comparisonFailSensation")}</b> {` `}
          {failSensation}
        </p>
      </div>
      <div>
        <p>
          <b>{t("pages.CareerDiagnose.comparisonSuccessSensation")}</b> {` `}
          {successSensation}
        </p>
      </div>
      <div>
        <p>
          <b>{t("pages.CareerDiagnose.comparisonWhatToDo")}</b> {` `}
          {whatToDo}
        </p>
      </div>
    </div>
  );
};

export default ComparisonExplain;
